import Auth from './models/auth'
import AuthController from './controllers/authController'
import AuthView from './views/authView'

const auth = new Auth()
const authController = AuthController(auth)

new AuthView(auth, authController)


/** WEBPACK FOOTER **
 ** ./htdocs_dev/js/auth/index.js
 **/